<div class="main-section">
<h2 class="dialog-heading outline-border-text">IAF Calculator
  <mat-icon class="close-icon" (click)="closeDialog()">close</mat-icon>
</h2>
<div>
  <div [formGroup]="IAFForm">
    <mat-form-field class="company-info ">
      <label class="text-header">Sales with this Corporate*</label>
      <input class="iaf-p-l" matInput noLeadingSpace  maxlength="15" appInputRestriction="integer"  formControlName="revenueWithParent" name="revenueWithParent" required step="any" (input)="validateNumber($event)">
      <mat-error *ngIf="getErrorMessage('revenueWithParent') &&showIafError">
        {{getErrorMessage('revenueWithParent')}}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="company-info ">
      <label class="text-header">Your Total Sales*</label>
      <input class="iaf-p-l"  matInput noLeadingSpace appInputRestriction="integer" maxlength="15" formControlName="totalRevenue" name="totalRevenue" required step="any" (input)="validateNumber($event)">
     
      <mat-error *ngIf="getErrorMessage('totalRevenue') &&showIafError">
        {{getErrorMessage('totalRevenue')}}
      </mat-error>
    </mat-form-field>

    <p class="dailog-iaf">
      IAF % = <strong>{{ calculatedIafPercentage | number:'1.2-2' }}% ({{ calculatedIafPercentage | number:'1.2-6' }}%)</strong>
    </p>
    <mat-error *ngIf="invalidCalculation">IAF value should not be more than 100%</mat-error>
  </div>
</div>
<div align="end">
  <button class="btn-white-border ms-2" type="submit" (click)="calculateIAF()">Calculate</button>
  <button class="btn-success ms-2" [disabled]="(!isFormValid() || invalidCalculation || calculatedIafPercentage <= 0)" (click)="applyCalculation()">Apply</button>
</div>
<p class="dailog-footer all-fields">Disclaimer: Total sales entered are used only for computation and will not be saved or retrievable later.</p>
</div>
